/* SNEAP product page: gallery, lightbox, variants, bundles, add-ons, delivery dates, sticky bar */
(function () {
  var S = (window.SNEAP = window.SNEAP || {});

  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var json = root.querySelector('[data-sn-product-json]');
    if (!json) return;
    var data = JSON.parse(json.textContent);
    var form = root.querySelector('[data-sn-form]');
    var idInput = root.querySelector('[data-sn-variant-id]');
    var qtyHidden = root.querySelector('[data-sn-qty-hidden]');
    var reduce = S.reduceMotion();
    var current = data.variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || data.variants[0];

    /* ================= Gallery ================= */
    var track = root.querySelector('[data-sn-track]');
    var slides = track ? [].slice.call(track.children) : [];
    var thumbs = [].slice.call(root.querySelectorAll('[data-sn-thumb]'));
    var counter = root.querySelector('[data-sn-counter]');
    var prev = root.querySelector('[data-sn-prev]'), next = root.querySelector('[data-sn-next]');
    var index = 0;
    function setActive(i) {
      index = i;
      thumbs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle('is-active', on);
        if (on) { t.setAttribute('aria-current', 'true'); var bar = t.parentNode; if (bar.scrollWidth > bar.clientWidth || bar.scrollHeight > bar.clientHeight) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); }
        else t.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = i + 1;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      slides.forEach(function (s, k) { var vid = s.querySelector('video'); if (vid && k !== i) vid.pause(); });
    }
    function go(i, instant) {
      if (!track || !slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: instant || reduce ? 'auto' : 'smooth' });
      setActive(i);
    }
    if (track) {
      var st;
      track.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== index) setActive(i);
        }, 60);
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(Number(t.dataset.snThumb)); }); });
      if (prev) prev.addEventListener('click', function () { go(index - 1); });
      if (next) next.addEventListener('click', function () { go(index + 1); });
      setActive(0);
    }
    function goToMedia(mediaId) {
      if (!mediaId) return;
      for (var k = 0; k < slides.length; k++) if (String(slides[k].dataset.mediaId) === String(mediaId)) { go(k); return; }
    }

    /* ================= Lightbox ================= */
    var lb = root.querySelector('[data-sn-lightbox]');
    if (lb) {
      var lbTrack = lb.querySelector('[data-sn-lb-track]');
      var lbSlides = [].slice.call(lbTrack.children);
      document.body.appendChild(lb);
      function lbGo(i) {
        var t = lbSlides.filter(function (f) { return Number(f.dataset.index) === i; })[0] || lbSlides[0];
        if (!t) return;
        var img = t.querySelector('img[data-src]'); if (img) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
        lbTrack.scrollTo({ left: t.offsetLeft, behavior: 'auto' });
      }
      function lbOpen(i, opener) {
        lbSlides.forEach(function (f) { var im = f.querySelector('img[data-src]'); if (im) { im.src = im.dataset.src; im.removeAttribute('data-src'); } });
        lb.removeAttribute('inert'); lb.setAttribute('aria-hidden', 'false'); lb.classList.add('is-open');
        S.lock(lb, opener);
        requestAnimationFrame(function () { lbGo(i); lb.querySelector('[data-sn-close]').focus(); });
      }
      function lbClose() {
        lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); lb.setAttribute('inert', '');
        lbSlides.forEach(function (f) { f.classList.remove('is-zoomed'); });
        S.unlock(lb);
      }
      root.querySelectorAll('[data-sn-zoom]').forEach(function (b) {
        b.addEventListener('click', function () { lbOpen(Number(b.dataset.snZoom), b); });
      });
      lb.querySelector('[data-sn-close]').addEventListener('click', lbClose);
      function lbStep(d) { lbTrack.scrollBy({ left: d * lbTrack.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); }
      lb.querySelector('[data-sn-lb-prev]').addEventListener('click', function () { lbStep(-1); });
      lb.querySelector('[data-sn-lb-next]').addEventListener('click', function () { lbStep(1); });
      lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') lbStep(1); if (e.key === 'ArrowLeft') lbStep(-1); });
      lbSlides.forEach(function (f) {
        f.addEventListener('click', function (e) {
          if (e.target.tagName !== 'IMG') return;
          if (window.matchMedia('(pointer: coarse)').matches) return; /* phones: pinch to zoom */
          var zoomed = f.classList.toggle('is-zoomed');
          if (zoomed) {
            var r = e.target.getBoundingClientRect();
            var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
            requestAnimationFrame(function () { f.scrollLeft = px * (f.scrollWidth - f.clientWidth); f.scrollTop = py * (f.scrollHeight - f.clientHeight); });
          }
        });
      });
    }

    /* ================= Price helpers ================= */
    var priceBlock = root.querySelector('[data-sn-price-block]');
    var bundle = root.querySelector('[data-sn-bundle]');
    var atc = root.querySelector('[data-sn-atc]');
    var atcLabel = root.querySelector('[data-sn-atc-label]');
    var atcPrice = root.querySelector('[data-sn-atc-price]');
    var stickyPrice = root.querySelector('[data-sn-sticky-price]');
    var stickyCompare = root.querySelector('[data-sn-sticky-compare]');
    var stickyBtn = root.querySelector('[data-sn-sticky-btn]');
    var saleBadge = root.querySelector('[data-sn-sale-badge]');

    function tierCalc(v, q, d) {
      var total = Math.round(v.price * q * (100 - d) / 100);
      var refUnit = v.compare_at_price > v.price ? v.compare_at_price : v.price;
      var ref = refUnit * q;
      var save = Math.max(0, ref - total);
      return { total: total, ref: ref, save: save, pct: ref ? Math.round(save * 100 / ref) : 0, per: Math.round(total / q), refPer: refUnit };
    }
    function selectedTier() {
      if (!bundle) return null;
      var t = bundle.querySelector('[data-sn-tier]:checked') || bundle.querySelector('[data-sn-tier]');
      return t ? { q: Number(t.dataset.qty) || 1, d: Number(t.dataset.disc) || 0, el: t } : null;
    }
    function quantity() {
      var t = selectedTier();
      if (t) return t.q;
      var qi = root.querySelector('[data-sn-main-qty-input]');
      return qi ? Math.max(1, parseInt(qi.value, 10) || 1) : 1;
    }

    function renderPrices() {
      var v = current;
      var t = selectedTier();
      var useBundle = t && bundle.dataset.updatePrice === 'true';
      var c = useBundle ? tierCalc(v, t.q, t.d) : tierCalc(v, 1, 0);
      if (priceBlock) {
        priceBlock.querySelector('[data-sn-price]').textContent = S.money(c.total);
        var cmp = priceBlock.querySelector('[data-sn-compare]');
        if (cmp) { cmp.textContent = S.money(c.ref); cmp.hidden = c.save <= 0; }
        var sv = priceBlock.querySelector('[data-sn-save]');
        if (sv) {
          sv.hidden = c.save <= 0;
          sv.querySelector('span').textContent = (priceBlock.dataset.prefix || '') + ' ' + (priceBlock.dataset.badge === 'amount' ? S.money(c.save) : c.pct + '%');
        }
      }
      var total = t ? tierCalc(v, t.q, t.d).total : v.price * quantity();
      if (atcPrice) atcPrice.textContent = '· ' + S.money(total);
      if (stickyPrice) stickyPrice.textContent = S.money(useBundle ? c.total : v.price);
      if (stickyCompare) { stickyCompare.textContent = S.money(useBundle ? c.ref : v.compare_at_price); stickyCompare.hidden = useBundle ? c.save <= 0 : !(v.compare_at_price > v.price); }
      if (saleBadge) {
        var one = tierCalc(v, 1, 0);
        saleBadge.hidden = one.save <= 0; saleBadge.textContent = '-' + one.pct + '%';
      }
      /* each bundle option */
      if (bundle) {
        bundle.querySelectorAll('[data-sn-tier]').forEach(function (inp) {
          var cc = tierCalc(v, Number(inp.dataset.qty) || 1, Number(inp.dataset.disc) || 0);
          var lab = inp.nextElementSibling;
          var set = function (sel, txt, hide) { var el = lab.querySelector(sel); if (el) { if (txt != null) el.textContent = txt; if (hide != null) el.hidden = hide; } };
          set('[data-sn-t-total]', S.money(cc.total));
          set('[data-sn-t-ref]', S.money(cc.ref), cc.save <= 0);
          set('[data-sn-t-per]', S.money(cc.per));
          set('[data-sn-t-refper]', S.money(cc.refPer), cc.save <= 0);
          var sub = lab.querySelector('[data-sn-sub]');
          if (sub && inp.dataset.sub) sub.textContent = inp.dataset.sub.replace('[percent]', cc.pct + '%').replace('[save]', S.money(cc.save));
        });
      }
      if (qtyHidden) qtyHidden.value = quantity();
    }

    function renderGifts() {
      if (!bundle) return;
      var q = quantity();
      bundle.querySelectorAll('.sn-bd__gift').forEach(function (g) {
        var open = q >= Number(g.dataset.unlock || 1);
        var was = g.classList.contains('is-open');
        g.classList.toggle('is-open', open);
        var sr = g.querySelector('[data-sn-gift-state]');
        if (sr) sr.textContent = open ? ' (unlocked)' : ' (unlocks at ' + g.dataset.unlock + ')';
        if (open && !was && !reduce) { g.animate && g.animate([{ transform: 'scale(.94)' }, { transform: 'scale(1.04)' }, { transform: 'scale(1)' }], { duration: 380, easing: 'ease-out' }); }
      });
    }

    /* ================= Variants ================= */
    var picker = root.querySelector('[data-sn-variants]');
    function selectedOptions() {
      var opts = [];
      if (!picker) return current.options.slice();
      picker.querySelectorAll('fieldset[data-opt-index]').forEach(function (fs) {
        var i = Number(fs.dataset.optIndex);
        var sel = fs.querySelector('select[data-sn-opt]');
        var r = fs.querySelector('input[data-sn-opt]:checked');
        opts[i] = sel ? sel.value : (r ? r.value : current.options[i]);
      });
      return opts;
    }
    function findVariant(opts) {
      return data.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0];
    }
    function markAvailability(opts) {
      if (!picker) return;
      picker.querySelectorAll('fieldset[data-opt-index]').forEach(function (fs) {
        var i = Number(fs.dataset.optIndex);
        fs.querySelectorAll('input[data-sn-opt]').forEach(function (inp) {
          var test = opts.slice(); test[i] = inp.value;
          var v = findVariant(test);
          var lab = fs.querySelector('label[for="' + inp.id + '"]');
          if (lab) lab.classList.toggle('is-na', !v || !v.available);
        });
        fs.querySelectorAll('select[data-sn-opt] option').forEach(function (o) {
          var test = opts.slice(); test[i] = o.value;
          var v = findVariant(test);
          o.textContent = o.value + (!v ? ' – ' + data.texts.unavailable : (!v.available ? ' – ' + data.texts.sold_out : ''));
        });
        var lbl = fs.querySelector('[data-sn-opt-label]');
        if (lbl) lbl.textContent = opts[i];
      });
    }
    function setButtons(v) {
      var ok = v && v.available;
      if (atc) {
        atc.disabled = !ok;
        if (atcLabel) atcLabel.textContent = !v ? data.texts.unavailable : (ok ? data.texts.add : data.texts.sold_out);
        if (atcPrice) atcPrice.hidden = !ok;
      }
      if (stickyBtn && !bundle) stickyBtn.disabled = !ok;
      var dyn = root.querySelector('[data-sn-dynamic]');
      if (dyn) dyn.style.display = ok ? '' : 'none';
    }
    /* SKU, unit price and local pickup for the selected variant */
    function renderVariantInfo(v) {
      var sku = root.querySelector('[data-sn-sku]');
      if (sku) { sku.hidden = !v.sku; var sv = sku.querySelector('[data-sn-sku-value]'); if (sv) sv.textContent = v.sku || ''; }
      var unit = root.querySelector('[data-sn-unit]');
      if (unit) { unit.innerHTML = v.unit || ''; unit.hidden = !v.unit; }
      var pick = root.querySelector('[data-sn-pickup]');
      if (pick) {
        fetch(S.url('variants/' + v.id + '/?section_id=sn-pickup'))
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (html) {
            if (String(current.id) !== String(v.id)) return;
            var d = new DOMParser().parseFromString(html, 'text/html');
            var src = d.querySelector('.shopify-section') || d.body;
            pick.innerHTML = src ? src.innerHTML : '';
          }).catch(function () {});
      }
    }
    /* 3D models + AR */
    var modelsJson = root.querySelector('[data-sn-models]');
    if (modelsJson && window.Shopify && Shopify.loadFeatures) {
      Shopify.loadFeatures([
        { name: 'model-viewer-ui', version: '1.0', onLoad: function (err) {
          if (err || !window.Shopify.ModelViewerUI) return;
          root.querySelectorAll('model-viewer').forEach(function (m) { if (!m.dataset.snUi) { m.dataset.snUi = '1'; new Shopify.ModelViewerUI(m); } });
        } },
        { name: 'shopify-xr', version: '1.0', onLoad: function (err) {
          if (err) return;
          var setup = function () { window.ShopifyXR.addModels(JSON.parse(modelsJson.textContent)); window.ShopifyXR.setupXRElements(); };
          if (window.ShopifyXR) setup(); else document.addEventListener('shopify_xr_initialized', setup);
        } }
      ]);
    }

    function onOptionChange() {
      var opts = selectedOptions();
      var v = findVariant(opts);
      markAvailability(opts);
      if (!v) { setButtons(null); return; }
      current = v;
      idInput.value = v.id;
      setButtons(v);
      renderPrices();
      if (v.media_id) goToMedia(v.media_id);
      if (root.dataset.updateUrl !== 'false' && window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      renderVariantInfo(v);
      root.dispatchEvent(new CustomEvent('sneap:variant-change', { bubbles: true, detail: { variant: v } }));
    }
    if (picker) {
      picker.addEventListener('change', onOptionChange);
      markAvailability(selectedOptions());
    }

    /* ================= Bundle ================= */
    if (bundle) {
      bundle.addEventListener('change', function (e) {
        if (e.target.matches('[data-sn-tier]')) { renderPrices(); renderGifts(); }
      });
    }

    /* ================= Quantity block ================= */
    root.querySelectorAll('[data-sn-main-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var qi = root.querySelector('[data-sn-main-qty-input]');
        qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) + Number(b.dataset.snMainQty));
        renderPrices();
      });
    });
    var qInput = root.querySelector('[data-sn-main-qty-input]');
    if (qInput) qInput.addEventListener('change', function () { qInput.value = Math.max(1, parseInt(qInput.value, 10) || 1); renderPrices(); });

    /* ================= Upsell: variant selects ================= */
    root.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-sn-card-variant], [data-sn-addon-variant]');
      if (!sel) return;
      var holder = sel.closest('li');
      var opt = sel.options[sel.selectedIndex];
      var price = holder.querySelector('[data-sn-up-price]');
      if (price && opt) price.textContent = opt.dataset.price;
      var add = holder.querySelector('[data-sn-add]');
      if (add) add.setAttribute('data-sn-add', sel.value + ':1');
      var box = holder.querySelector('[data-sn-addon]');
      if (box) box.value = sel.value;
    });

    /* ================= Add to cart ================= */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!current || !current.available) return;
        var items = [{ id: current.id, quantity: quantity() }];
        root.querySelectorAll('[data-sn-addon]:checked').forEach(function (c) { items.push({ id: Number(c.value), quantity: 1 }); });
        if (bundle && bundle.dataset.autoGifts === 'true') {
          bundle.querySelectorAll('.sn-bd__gift.is-open').forEach(function (g) {
            var gv = Number(g.dataset.giftVariant || 0);
            if (gv) items.push({ id: gv, quantity: 1, properties: { _sn_gift: 'yes' } });
          });
        }
        var err = root.querySelector('[data-sn-error]'); if (err) err.hidden = true;
        S.addToCart(items, atc).catch(function (er) { if (err) { err.textContent = er.message; err.hidden = false; } });
      });
    }

    /* ================= Better together ================= */
    var togethers = [].slice.call(root.querySelectorAll('[data-sn-together]'));
    function renderTogether() {
      togethers.forEach(function (bt) {
        var sel = bt.querySelector('[data-sn-bt-variant]');
        var opt = sel ? sel.options[sel.selectedIndex] : null;
        var ap = Number(opt ? opt.dataset.price : bt.dataset.addonPrice) || 0;
        var ar = Number(opt ? opt.dataset.ref : bt.dataset.addonRef) || ap;
        var mr = current.compare_at_price > current.price ? current.compare_at_price : current.price;
        var total = current.price + ap, ref = mr + ar, save = ref - total;
        bt.querySelector('[data-sn-bt-total]').textContent = S.money(total);
        var r = bt.querySelector('[data-sn-bt-ref]'); r.textContent = S.money(ref); r.hidden = save <= 0;
        var sv = bt.querySelector('[data-sn-bt-save]');
        if (sv) { sv.hidden = save <= 0; sv.textContent = sv.dataset.text.replace('[amount]', S.money(save)); }
        var b = bt.querySelector('[data-sn-bt-add]');
        if (sel) b.dataset.addon = sel.value;
        b.disabled = !current.available;
      });
    }
    togethers.forEach(function (bt) {
      var sel = bt.querySelector('[data-sn-bt-variant]');
      if (sel) sel.addEventListener('change', renderTogether);
      var b = bt.querySelector('[data-sn-bt-add]');
      b.addEventListener('click', function () {
        if (!current || !current.available) return;
        var err = root.querySelector('[data-sn-error]'); if (err) err.hidden = true;
        S.addToCart([{ id: current.id, quantity: 1 }, { id: Number(b.dataset.addon), quantity: 1 }], b)
          .catch(function (er) { if (err) { err.textContent = er.message; err.hidden = false; } });
      });
    });

    /* ================= Stock / selling fast ================= */
    var stocks = [].slice.call(root.querySelectorAll('[data-sn-stock]'));
    function renderStock() {
      stocks.forEach(function (st) {
        var map = {}; try { map = JSON.parse(st.querySelector('[data-sn-stock-map]').textContent); } catch (e) {}
        var q = map[String(current.id)];
        var thr = Number(st.dataset.thr) || 20, batch = Number(st.dataset.batch) || 0;
        var show = q != null && q > 0 && (st.hasAttribute('data-always') || q <= thr);
        if (!show && st.hasAttribute('data-preview')) return;
        st.hidden = !show;
        if (!show) return;
        var pct = batch > q ? Math.floor((batch - q) * 100 / batch) : Math.max(0, 100 - Math.floor(q * 100 / thr));
        var line = (batch > q ? st.dataset.barText : st.dataset.countText).replace('[percent]', pct).replace('[qty]', q);
        st.style.setProperty('--st-p', pct + '%');
        st.querySelectorAll('[data-sn-stock-line]').forEach(function (el) { el.textContent = line; });
        st.querySelectorAll('[data-sn-stock-count]').forEach(function (el) { el.textContent = st.dataset.countText.replace('[qty]', q); });
        var bar = st.querySelector('.sn-pb-stock__bar'); if (bar) bar.setAttribute('aria-label', line);
        var lit = Math.floor((pct + 5) / 10);
        st.querySelectorAll('.sn-pb-stock__seg i').forEach(function (s, k) { s.classList.toggle('is-on', k < lit); });
      });
    }
    root.addEventListener('sneap:variant-change', function () { renderTogether(); renderStock(); });

    /* ================= Delivery dates ================= */
    root.querySelectorAll('[data-sn-delivery]').forEach(function (d) {
      var lang = document.documentElement.lang || undefined;
      function addBiz(date, n) {
        var x = new Date(date.getTime());
        while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
        return x;
      }
      function fmt(x, long) { try { return x.toLocaleDateString(lang, long ? { weekday: 'short', month: 'short', day: 'numeric' } : { month: 'short', day: 'numeric' }); } catch (er) { return x.toDateString(); } }
      var now = new Date();
      var ship = addBiz(now, Number(d.dataset.ship) || 0), a = addBiz(now, Number(d.dataset.min) || 1), b = addBiz(now, Number(d.dataset.max) || 1);
      var set = function (k, txt) { var el = d.querySelector('[data-sn-d="' + k + '"]'); if (el) el.textContent = txt; };
      set('today', fmt(now));
      set('ship', fmt(ship));
      set('range', fmt(a) + ' – ' + fmt(b));
      var line = d.querySelector('[data-sn-d-text]');
      if (line) line.innerHTML = S.esc(line.dataset.snDText).replace('[start]', '<b>' + S.esc(fmt(a, true)) + '</b>').replace('[end]', '<b>' + S.esc(fmt(b, true)) + '</b>');
    });

    /* ================= Sticky add-to-cart bar ================= */
    var sticky = root.querySelector('[data-sn-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      document.body.appendChild(sticky);
      var target = root.querySelector('[data-sn-buy-area]') || atc;
      var visible = true, pastIt = false;
      function sync() {
        var on = !visible && pastIt;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        stickyBtn.tabIndex = on ? 0 : -1;
      }
      if (target) {
        new IntersectionObserver(function (es) {
          visible = es[0].isIntersecting;
          pastIt = es[0].boundingClientRect.top < 0;
          sync();
        }).observe(target);
      }
      stickyBtn.addEventListener('click', function () {
        if (bundle || !current.available) { S.scrollToBuy(); return; }
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }

    renderPrices();
    renderGifts();
  }

  function boot() { document.querySelectorAll('[data-sn-product]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
